{
  "CREATE_USER": {
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "EMAIL": "Email",
    "ERROR_SNACK": "Error creating user",
    "RATE_LIMIT_SNACK": "Limit has been reached for business users",
    "CREATE_USER_SUCCESS": "User successfully created",
    "INVALID_FORM": "Invalid user form. Verify the information provided"
  },
  "ADD_USER_DIALOG_LIBRARY": {
    "ADD_USERS_TO_ACCOUNT": "Add users to account",
    "ADD_USER_TO_BRAND": "Add user to group",
    "ENTIRE_BRAND": "Entire group",
    "SELECT_SUBGROUPS": "Select sub-groups",
    "NONE_FOUND": "None found",
    "CREATE_NEW_USER": "Create New User",
    "CREATE_USER": "Create user",
    "ADD_USERS": "Add users",
    "ADD_EXISTING_USER": "Add existing user",
    "CANCEL": "Cancel",
    "CLOSE": "Close"
  }
}
